"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5371%3A959))
 * @lastsynced 2026-10-29T13:50:27.823Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ClipboardCheck = createSVGIcon(
  <path
    d="M16.714 2.692h2.572c.454 0 .89.179 1.212.496S21 3.936 21 4.385v16.923c0 .448-.18.88-.502 1.196a1.73 1.73 0 0 1-1.212.496H4.714c-.454 0-.89-.178-1.212-.496A1.68 1.68 0 0 1 3 21.308V4.385c0-.45.18-.88.502-1.197a1.73 1.73 0 0 1 1.212-.496h2.572M8.57 15.384l2.572 1.693 5.143-6.77M14.57 1H9.428c-.946 0-1.714.758-1.714 1.692v.846c0 .935.768 1.693 1.714 1.693h5.143c.947 0 1.714-.758 1.714-1.693v-.846c0-.934-.767-1.692-1.714-1.692Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ClipboardCheck",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
